var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ACEE",
    d: "M27.509 5.775c-.972.435-2.015.728-3.112.86a5.474 5.474 0 0 0 2.382-3.025 10.762 10.762 0 0 1-3.44 1.326 5.394 5.394 0 0 0-3.956-1.725c-2.992 0-5.42 2.448-5.42 5.47 0 .427.05.842.14 1.244-4.505-.23-8.497-2.407-11.17-5.714A5.503 5.503 0 0 0 2.2 6.96c0 1.896.958 3.571 2.41 4.552a5.371 5.371 0 0 1-2.454-.685v.07c0 2.65 1.867 4.86 4.347 5.362a5.414 5.414 0 0 1-2.447.094c.69 2.172 2.69 3.754 5.063 3.796a10.814 10.814 0 0 1-6.732 2.342c-.437 0-.869-.026-1.293-.077A15.228 15.228 0 0 0 9.4 24.871c9.97 0 15.42-8.331 15.42-15.557 0-.235-.006-.472-.016-.706a11.073 11.073 0 0 0 2.703-2.83l.002-.003"
  })));
};
export default SvgTwitterinline;